import React from 'react';
import PageContainer from '../../common/components/Page/PageContainer';
import RegionsManagerContainer from './components/RegionsManager/RegionsManagerContainer';
import PermissionsCheck from '../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../common/constants/PermissionsEnum';
import './Regions.css';

const Regions = () => (
  <PageContainer pageName="regions">
    <PermissionsCheck appliedToPage={true} permission={PermissionsEnum.VIEW_REGIONS}>
      <RegionsManagerContainer />
    </PermissionsCheck>
  </PageContainer>
);

export default Regions;
